import { Button, Tooltip } from "antd";
import { getButtonStyle } from "./utils";

type IconButtonProps = {
  icon: React.ReactNode;
  title?: string;
  onClick?: () => void;
  disabled?: boolean;
  isActive?: boolean;
  isOpen?: boolean;
  className?: string;
  style?: React.CSSProperties;
  mouseEnterDelay?: number;
  "data-testid"?: string;
  placement?:
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "topLeft"
    | "topRight"
    | "bottomLeft"
    | "bottomRight"
    | "leftTop"
    | "leftBottom"
    | "rightTop"
    | "rightBottom";
};

export const IconButton = ({
  icon,
  title,
  onClick,
  disabled = false,
  isActive,
  isOpen,
  className = "",
  style = {},
  mouseEnterDelay = 0.3,
  placement = "top",
  "data-testid": dataTestId,
}: IconButtonProps) => {
  const baseStyle = getButtonStyle({
    isOpen,
    isActive,
    isDisabled: disabled,
  });

  return (
    <Tooltip
      mouseEnterDelay={mouseEnterDelay}
      title={title}
      placement={placement}
    >
      <Button
        data-testid={dataTestId}
        disabled={disabled}
        onClick={onClick || (() => {})}
        className={`p-[6px] h-[38px] w-[38px] rounded-md border flex items-center justify-center ${className} disabled:cursor-not-allowed`}
        /**
         * antd's own button padding beats the Tailwind `p-[6px]` above, leaving ~6px of
         * content and squashing a 24px icon to a sliver. Set inline so it wins, before
         * `style` so a caller can still override.
         */
        style={{ padding: 6, ...baseStyle, ...style }}
      >
        {icon}
      </Button>
    </Tooltip>
  );
};
